import { forwardRef } from 'react';
import { Disableable, Sized, useThemeValue, Variable } from '@optimus-web/common';
import { IconName } from '@optimus-web/icons';
import { IconButtonVariant } from '@optimus-web/local-tokens';
import { CircleLoader } from '../CircleLoader';
import { VisuallyHidden } from '../helpers/VisuallyHidden';
import { IconButtonElement } from './style';

export interface IconButtonProps
    extends Sized,
        Variable<IconButtonVariant>,
        Disableable,
        React.ButtonHTMLAttributes<HTMLButtonElement> {
    ref?: React.Ref<HTMLButtonElement>;
    icon: IconName;
    iconSize?: 'small' | 'medium';
    onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
    accessibleText?: React.ReactChild;
    loading?: boolean;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
    (
        { icon, size: customSize, iconSize = 'small', variant, accessibleText, loading, ...other }: IconButtonProps,
        ref
    ) => (
        <IconButtonElement
            ref={ref}
            icon={loading ? undefined : icon}
            iconSize={iconSize}
            size={useThemeValue('iconButton', customSize)}
            variant={variant}
            {...other}
        >
            {loading && <CircleLoader size="small" />}
            {accessibleText && <VisuallyHidden>{accessibleText}</VisuallyHidden>}
        </IconButtonElement>
    )
);

export default IconButton;
